import { render, staticRenderFns } from "./GamePreviewCard.vue?vue&type=template&id=3c16a1e0&scoped=true"
import script from "./GamePreviewCard.vue?vue&type=script&lang=js"
export * from "./GamePreviewCard.vue?vue&type=script&lang=js"
import style0 from "./GamePreviewCard.vue?vue&type=style&index=0&id=3c16a1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c16a1e0",
  null
  
)

export default component.exports